"use client";

import React from "react";

export interface TalktribeIntroBlockProps {
    tag?: string;
    title?: string;
    titleHighlight?: string;
    paragraphs?: string[];
}

export default function TalktribeIntroBlock({
    tag = "// The Product",
    title = "A Platform for AI Conversations That Remember",
    titleHighlight = "AI Conversations",
    paragraphs = [
        "TalkTribe is designed to explore the boundaries of persona-based chatbot interaction. By integrating advanced generative models with structured system cues and Vector database persistence, the system delivers deep, contextual conversations.",
        "Unlike simple conversational loops that reset with every browser tab refresh, TalkTribe features built-in persistent memory per character. Every user action, detail, and conversation is stored and remembered, mirroring real human relations over time."
    ]
}: TalktribeIntroBlockProps) {
    const renderTitle = () => {
        if (!title || !titleHighlight || !title.includes(titleHighlight)) return title;
        const parts = title.split(titleHighlight);
        return (
            <>
                {parts[0]}
                <span className="text-zinc-600">{titleHighlight}</span>
                {parts[1]}
            </>
        );
    };

    return (
        <section className="py-28 px-6 md:px-12 lg:px-24 bg-[#060608] w-full" data-header-theme="light">
            <div className="container mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                    <div className="lg:col-span-5">
                        {tag && (
                            <span className="text-xs font-mono text-violet-400 uppercase tracking-widest block mb-4">
                                {tag}
                            </span>
                        )}
                        <h2 className="text-4xl md:text-5xl font-light text-white leading-tight">
                            {renderTitle()}
                        </h2>
                    </div>
                    <div className="lg:col-span-7 space-y-6 text-zinc-400 text-sm md:text-base leading-relaxed font-light">
                        {paragraphs.map((para, i) => (
                            <p key={i}>{para}</p>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
